import { useState } from "react";
import { Box } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import { Button } from "./Button";

interface Props {
  onBack?: () => void;
  /**
   * Si regresa una promesa (`formik.submitForm` o un handler `async`), mientras se resuelve se deshabilitan los dos
   * botones: así no se puede regresar ni volver a continuar a medio guardado.
   */
  onNext: () => unknown;
  backLabel?: string;
  nextLabel?: string;
  nextDisabled?: boolean;
  /** data-testid del botón "Regresar", para pruebas automatizadas. */
  backTestId?: string;
  /** data-testid del botón "Continuar", para pruebas automatizadas. */
  nextTestId?: string;
}

export const StepActions = ({
  onBack,
  onNext,
  backLabel = "Regresar",
  nextLabel = "Continuar",
  nextDisabled,
  backTestId,
  nextTestId,
}: Props) => {
  const [isPending, setIsPending] = useState(false);

  const handleNext = async () => {
    const result = onNext();
    if (!(result instanceof Promise)) return;
    setIsPending(true);
    try {
      await result;
    } finally {
      setIsPending(false);
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4, gap: 2 }}>
      {onBack ? (
        <Button
          tone="ghost"
          startIcon={<ChevronLeft fontSize="small" />}
          onClick={onBack}
          disabled={isPending}
          data-testid={backTestId}
        >
          {backLabel}
        </Button>
      ) : (
        <Box />
      )}
      <Button
        tone="primary"
        onClick={handleNext}
        disabled={nextDisabled || isPending}
        withArrow
        data-testid={nextTestId}
      >
        {nextLabel}
      </Button>
    </Box>
  );
};
